/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useState, useEffect } from "react";
import {
  Box,
  List,
  Divider,
  Tooltip,
  ListItem,
  IconButton,
  CssBaseline,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isIFrame } from "@jda/lui-portal-utilities";
import { LuiLogoPlus } from "@jda/lui-common-component-library-mui5";
import { ArrowChevronLeft, CatalogGrid, CatalogRows, PlaceInstitution, LayoutSidebar } from "@jda/lui-common-icon-library-mui5";

import { ListOfPages } from "./constants";
import { Icons } from "../../assets/Icons/Icons";
import { StyledDrawer, useStyles } from "./styles";
import { selectAllAssignedPermissions } from '../../store/auth/authSelector';
import { actions, resources } from "../../components/checkPermission/constants";
import { checkAuthzPermission } from "../../components/checkPermission/CheckViewPermission";

export const Breadcrumbs = () => {
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<undefined | string>("0");

  const classes = useStyles();
  const history = useHistory();
  const assignedPermissions = useSelector(selectAllAssignedPermissions);

  const orgView = assignedPermissions &&
    assignedPermissions.resources &&
    checkAuthzPermission(actions.VIEW, assignedPermissions.resources[resources.ORGANIZATION]);
  const customerView = assignedPermissions &&
    assignedPermissions.resources &&
    checkAuthzPermission(actions.VIEW, assignedPermissions.resources[resources.CUSTOMER]);
  const filteredListOfPages: any = []
  if (orgView && customerView) {
    filteredListOfPages.push(...ListOfPages);
  } else if (orgView && !customerView) {
    filteredListOfPages.push(ListOfPages.find(page => page.key === "organizations"));
  } else if (!orgView && customerView) {
    filteredListOfPages.push(ListOfPages.find(page => page.key === "customers"));
  }

  const onClick = (index: number) => {
    setSelectedIndex(`${index}`);
    console.log("history ------->", history.location, history.location.search.split("=")[1]);
    if (index === 0) history.replace("/");
    else if (index === 1) history.replace("/organization");
    // else if (index === 2) history.replace(`/app-catalog?appCatalog
    else if (index === 2) window.open(`${JSON.parse(history.location.search.split("=")[1])}/app-catalog`, "_blank");
  };

  const toggleDrawer = (ev) => {
    ev.stopPropagation();
    if (open) setOpen(false);
    else setOpen(true);
  };
  const onLogoClick = () => {
    history.replace("/");
  }
  useEffect(() => {
    if (open) {
      document.addEventListener("click", (_event) => {
        _event.stopPropagation();
        // Close the list when clicking outside
        setOpen(false);
      });
      return () => {
        document.removeEventListener("click", () => {
          setOpen(false);
        });
      };
    }
  }, [open]);
  console.log("selectedIndex ----->", selectedIndex);
  return (
    <Box className={classes.drawerWrapper}>
      <Box minWidth="100%" display="flex" justifyContent="center" alignItems="flex-start">
        <CssBaseline />
        <Box display="flex" width="100%">
          <StyledDrawer variant="permanent" open={open}>
            {!isIFrame() ?
              <Box className={classes.byLogo}>
                <IconButton aria-label="Toggle Drawer" onClick={onLogoClick} size="small" className={classes.listItemButton} variant="contained" color="secondary">
                  <LuiLogoPlus fontSize="small" color="secondary" />
                </IconButton>
              </Box> : null
            }
            {filteredListOfPages.map(({ name, key, index }) => (
            <Box key={key}>
                <IconButton className={`${classes.listItemButton} ${`${index}` === selectedIndex ? "selectedListItem": ""}`} aria-label={name} onClick={() => onClick(index)} size="small" variant="contained" color="secondary">
                  {index === 0 ? (
                          <Tooltip arrow title={name} placement="right">
                            <div className={classes.iconWithText}>
                              <PlaceInstitution fontSize="small"/>
                              {open && <Typography variant="h4" component={'p'} color={'white'}>{name}</Typography>}
                            </div>
                          </Tooltip>
                        ) : index === 1 && (
                          <Tooltip arrow title={name} placement="right">
                            <div className={classes.iconWithText}>
                              <CatalogRows fontSize="small"/>
                               {open && <Typography variant="h4" component={'p'} color={'white'}>{name}</Typography>}
                            </div>
                          </Tooltip>
                        )}
                </IconButton>
            </Box> ))}
            {/* <List>
              {filteredListOfPages.map(({ name, key, index }) => (
                <li key={key} className={classes.listItemButton}>
                  <ListItem  key={key} className={classes.listItemButton}>
                    <ListItemButton disableGutters >
                      <ListItemIcon aria-label={name} className={classes.listItemIcon}>
                        {index === 0 ? (
                          <Tooltip arrow title={name} placement="right">
                            <div>
                              <PlaceInstitution fontSize="small"/>
                            </div>
                          </Tooltip>
                        ) : index === 1 && (
                          <Tooltip arrow title={name} placement="right">
                            <div>
                              <CatalogRows fontSize="small"/>
                            </div>
                          </Tooltip>
                        )}
                      </ListItemIcon>
                      <ListItemText
                        aria-label={name}
                        primary={name}
                        primaryTypographyProps={{
                          fontSize: Tokens.sizing.textLarge,
                          color: "white",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                </li>
              ))}
            </List> */}

            <Box my={0} mx={1} display="flex" alignItems="center" justifyContent={open ? "flex-end" : "flex-start"} className={classes.listItemButtonBottom}>
              <Tooltip arrow title={open ? "Collapse" : "Expand"} placement="right">
                <IconButton aria-label="Toggle Drawer" onClick={toggleDrawer} size="large" className={classes.listItemIconButtonBottom}>
                  <LayoutSidebar fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </StyledDrawer>
        </Box>
      </Box>
    </Box>
  );
};
